module.exports = __webpack_public_path__ + "images/bannerDE-c9f54407561bbd481522b994cc6caae8.png";